import { Box, Button, List, ListItemButton, ListItemText, TextField, Typography } from "@mui/material"
import React, { useEffect, useState } from "react"
import { InventoryCheckUpdateUser, InventoryCheckUser } from "../entities/InventoryCheck"
import { useApi } from "../../../hooks/useApi"
import { getUserAvailable, updateInventoryCheckDetailUser } from "../api"
import { Loading } from "../../../components/UI/Loading/Loading"
import { Status } from "../../../hooks/useFetchState"


interface ReassignInventoryCheckModalProps {
  inventoryCheckDetailId: number
  inventoryCheckId: number
    handleCloseModal: () => void
    handleSnackbar: (message: string, success: boolean) => void
    requestInventoryCheckDetail : (
      inventoryCheckId: number) => void
  }
  
  export const ChangeUserInventoryCheckModal: React.FC<ReassignInventoryCheckModalProps> =({ 
      inventoryCheckDetailId, 
      inventoryCheckId,
      handleCloseModal, 
      handleSnackbar,
      requestInventoryCheckDetail
    }) => {

    const [loading, setLoading] = useState<boolean>(false)
      const { state, callApi } = useApi<InventoryCheckUser[]>()


          const requestGetUserList = () => {
            setLoading(true)
            callApi(getUserAvailable(inventoryCheckDetailId))
              .then(() => {
                setLoading(false)
              })
              .catch((error) => {
                handleSnackbar(error, false)
              })
            setLoading(false)
          }
        
          useEffect(() => {
            requestGetUserList()
          }, [])

          const [selectedId, setSelectedId] = useState<number | null>(null);
          const [searchText, setSearchText] = useState<string>("");
        
          // Filtrar los usuarios basados en el texto de búsqueda
          const filteredItems = (state.data || []).filter((item) =>
            item.username.toLowerCase().includes(searchText.toLowerCase())
          );

          const handleSelect = (id: number) => {
            setSelectedId(id);
          };

          const requestUpdateUser = () => {
            if (selectedId !== null) {
              const userDto: InventoryCheckUpdateUser = {userId: selectedId};

              setLoading(true)
              callApi(updateInventoryCheckDetailUser(inventoryCheckDetailId, userDto))
                .then(() => {
                  handleSnackbar('Usuario actualizado correctamente', true)
                  requestInventoryCheckDetail(inventoryCheckId)
                })
                .catch((error) => {
                  handleSnackbar(error, false)
                })
                .finally(()=> {
                  setLoading(false)
                  handleCloseModal()
                })
            }
          }

          if (state.status === Status.Loading || loading) {
            return (
              <div>
                <Typography>
                  <Loading />
                </Typography>
              </div>
            )
          } else {
          return (
            <Box
              style={{
                maxWidth: "400px",
                margin: "auto",
                padding: "16px",
                border: "1px solid #ccc",
                borderRadius: "8px",
              }}
            >
              <Typography variant="h6" gutterBottom>
                Seleccione Usuario:
              </Typography>
        
              {/* Campo de búsqueda */}
              <TextField
                fullWidth
                variant="outlined"
                size="small"
                placeholder="Buscar usuario..."
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                style={{ marginBottom: "16px" }}
              />
        
              {/* Lista filtrada */}
              <List style={{ maxHeight: "200px", overflowY: "auto" }}>
                {filteredItems.map((item) => (
                  <ListItemButton
                    key={item.userId}
                    selected={selectedId === item.userId}
                    onClick={() => handleSelect(item.userId)}
                    style={{
                      border: "1px solid #ccc",
                      margin: "2px 0",
                      borderRadius: "6px",
                      padding: "4px",
                      paddingLeft: "16px",
                      color: selectedId === item.userId ? "white" : "black",
                      backgroundColor: selectedId === item.userId ? "#3f51b5" : "white",
                    }}
                  >
                    <ListItemText primary={item.username} />
                  </ListItemButton>
                ))}
        
                {/* Mensaje si no hay resultados */}
                {filteredItems.length === 0 && (
                  <Typography variant="body2" color="textSecondary" align="center">
                    No se encontraron usuarios.
                  </Typography>
                )}
              </List>
        
              <Button
                variant="contained"
                color="primary"
                onClick={requestUpdateUser}
                style={{ marginTop: "16px", width: "100%" }}
                disabled={selectedId === null}
              >
                Guardar
              </Button>
            </Box>
          );}
        };
